<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="(user.UserId ? 'Edit User' : 'Create User') + ' :: MeritEHS'" />

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light" v-if="this.$root.hasPermission('settings.manage.users')">
                        <router-link :to="`/users`">
                            <i class="fa fa-user"></i> Users
                        </router-link>
                    </li>
                    <template v-else>
                        <li class="breadcrumb-item font-weight-light">
                            <router-link :to="`/subcontractors`">
                                <i class="fa fa-id-badge"></i> Subcontractors
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/subcontractors/users`">
                            <i class="fa fa-group"></i> Users
                        </router-link>
                    </li>
                    </template>
                    <template v-if="user.UserId">
                        <li class="breadcrumb-item font-weight-light">
                            <router-link :to="`/users/view/${user.UserId}`">
                                {{ user.FirstName }} {{ user.LastName }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active">
                            Edit
                        </li>
                    </template>
                    <li class="breadcrumb-item active" v-else>
                        New User
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-lg-8 mb-lg-0 mb-4">
                    <div class="card">
                        <div class="card-header">Basic Details</div>
                        <div class="card-body">
                            <div class="row form-group">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.FirstName}">
                                    First Name: <i class="fa fa-asterisk text-danger small"></i>
                                </label>
                                <div class="col-sm-8">
                                    <input type="text" name="FirstName" v-model="user.FirstName" :class="{'form-control': true, 'is-invalid': errors.FirstName}" placeholder="Enter First Name (Required)" />
                                    <span v-if="errors.FirstName" class="text-danger">
                                        <span v-for="error in errors.FirstName">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="row form-group">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.LastName}">
                                    Last Name: <i class="fa fa-asterisk text-danger small"></i>
                                </label>
                                <div class="col-sm-8">
                                    <input type="text" v-model="user.LastName" :class="{'form-control': true, 'is-invalid': errors.LastName}" placeholder="Enter Last Name (Required)" />
                                    <span v-if="errors.LastName" class="text-danger">
                                        <span v-for="error in errors.LastName">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="row form-group">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.email}">
                                    Email: <i class="fa fa-asterisk text-danger small"></i>
                                </label>
                                <div class="col-sm-8">
                                    <input type="email" v-model="user.email" :class="{'form-control': true, 'is-invalid': errors.email}" placeholder="Enter Email (Required)" />
                                    <span v-if="errors.existing_user" class="text-danger">
                                        This user already exists on your account. <a href="javascript:void(0)" @click="switchUser()">Click here</a> to edit this user.
                                    </span>
                                    <span v-else-if="errors.restore_user" class="text-danger">
                                        This user has been deleted. <a href="javascript:void(0)" @click="restoreUser()">Click here</a> to restore this user.
                                    </span>
                                    <span v-else-if="errors.not_sub_user" class="text-danger">
                                        This user is inactive or deleted, but is not a subcontractor user. A user with full user management rights will need to restore them.
                                    </span>
                                    <span v-else-if="errors.reactivate_user" class="text-danger">
                                        The user has been marked inactive. <a href="javascript:void(0)" @click="reactivateUser()">Click here</a> to reactivate this user.
                                    </span>
                                    <span v-else-if="errors.email" class="text-danger">
                                        <span v-for="error in errors.email">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="row form-group">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.title}">Title:</label>
                                <div class="col-sm-8">
                                    <input type="text" v-model="user.title" :class="{'form-control': true, 'is-invalid': errors.title}" placeholder="Enter Job Title" />
                                    <span v-if="errors.title" class="text-danger">
                                        <span v-for="error in errors.title">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="row form-group" v-if="isAdmin">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.EmployeeId}">Employee Record:</label>
                                <div class="col-sm-8">

                                    <employee-select ref="userEmployee" :selectedValues="userEmployee" @vselected="setUserEmployee" :hasError="errors.EmployeeId ? true : false"></employee-select>

                                    <div v-if="errors.EmployeeId" class="text-danger">
                                        <span v-for="error in errors.EmployeeId">{{ error }}</span>
                                    </div>
                                    <div v-if="errors.existing_employee" class="text-danger">
                                        A user with this employee already exists. Click <router-link :to="`/users/view/${errors.existing_employee}`">here</router-link> to view the other user.
                                    </div>

                                    <template  v-if="this.$root.hasPermission('employees.manage')">
                                            <div class="mt-1 mb-1">
                                                <a href="javascript:void(0)" v-on:click="showNewEmpModal()"><small><i class="fa fa-plus"></i> Create a New Employee Record </small></a>
                                            </div>

                                            <div>
                                                <employee-modal ref="newEmpModal" :empDetails="empDetails" :showButton="false" />
                                            </div>
                                    </template>

                                </div>
                            </div>
                            <div class="row form-group">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.title}">Primary Division:</label>
                                <div class="col-sm-8 pt-2">
                                    <span v-if="user.division_code">{{ user.division_code }} -</span> {{ user.DivisionName }}
                                    <div class="text-info">Division is pulled from the User's linked Employee Record.</div>
                                </div>
                            </div>
                            <div class="row form-group">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.title}">Assigned Jobsites ({{ jobsites.length }}):</label>
                                <div class="col-sm-8 pt-2">
                                    <div v-for="jobsite in jobsites" class="mb-1">
                                        <router-link :to="`/jobsites/view/${jobsite.JobsiteId}`">
                                            <span v-if="jobsite.JobsiteNumber">{{ jobsite.JobsiteNumber }} - </span>{{ jobsite.JobsiteName }}
                                        </router-link>
                                    </div>

                                    <div class="text-info">Assigned Jobsites are pulled from the User's linked Employee Record.</div>
                                </div>
                            </div>
                            <hr/>

                            <div class="form-group row">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.subcontractor_id}">
                                    Subcontractor:
                                    <template v-if="isAdmin"><br>(Optional)</template>
                                </label>
                                <div class="col-sm-8">
                                    <select v-model="user.subcontractor_id" :class="{'form-control': true, 'is-invalid': errors.subcontractor_id}">
                                        <option v-if="user.subcontractor_id === undefined" :value="undefined">-- Select a Subcontractor --</option>
                                        <option v-else :value="null">-- Select a Subcontractor --</option>
                                        <option v-for="sub in subcontractors" v-bind:value="sub.subcontractor_id">
                                            {{ sub.subcontractor_name }}
                                        </option>
                                    </select>

                                    <span v-if="errors.subcontractor_id" class="text-danger">
                                        <span v-for="error in errors.subcontractor_id">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div class="form-group row" v-if="user.subcontractor_id">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.sub_permissions}">
                                    Qualification Permissions:
                                </label>
                                <div class="col-sm-8">
                                    <select v-model="user.sub_permissions" :class="{'form-control': true, 'is-invalid': errors.sub_permissions}">
                                        <option :value="null">-- Select Qualification Permissions --</option>
                                        <option v-for="(value, key) in sub_permissions" v-bind:value="key">
                                            {{ value }}
                                        </option>
                                    </select>
                                    <div v-if="errors.sub_permissions" class="text-danger">
                                        <span v-for="error in errors.sub_permissions">{{ error }}</span>
                                    </div>
                                    <div class="alert alert-info mt-1">
                                        <small><strong>Qualification Permissions</strong> allow the subcontractor user to view/edit their pre-qualification data. Without this, they cannot view/edit the qualification form.</small>
                                    </div>
                                </div>
                            </div>
                            <hr/>

                            <div class="row form-group">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.IsActive}">Active:</label>
                                <div class="col-sm-8">
                                    <b-form-radio-group v-model="user.IsActive" class="mt-2" plain>
                                        <b-form-radio value="1">Active</b-form-radio>
                                        <b-form-radio value="0">Inactive</b-form-radio>
                                    </b-form-radio-group>

                                    <span v-if="errors.IsActive" class="text-danger">
                                        <span v-for="error in errors.IsActive">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="row form-group">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.timezone_slug}">Timezone</label>
                                <div class="col-sm-8">
                                    <select v-model="user.timezone_slug" :class="{'form-control': true, 'is-invalid': errors.timezone_slug}">
                                        <option :value="undefined">-- Select a Timezone --</option>
                                        <option v-for="timezone in timezones" :value="timezone.zone_slug">
                                            {{ timezone.display_name }}
                                        </option>
                                    </select>
                                    <span v-if="errors.timezone_slug" class="text-danger">
                                        <span v-for="error in errors.timezone_slug">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <hr>

                            <template v-if="user.subcontractor_id">
                                <div class="row form-group">
                                    <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.password}">Set Password:</label>
                                    <div class="col-sm-8">
                                        <input type="password" name="password" class="form-control" placeholder="Enter a Password" v-model="new_password" />
                                        <small class="text-info">Minimum 8 Charaters</small>

                                        <div v-if="errors.password" class="text-danger">
                                            <span v-for="error in errors.password">{{ error }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.password}">Confirm Password:</label>
                                    <div class="col-sm-8">
                                        <input type="password" name="password_confirmation" class="form-control" placeholder="Re-enter the password" v-model="new_password_confirmed" />
                                    </div>
                                </div>
                            </template>

                            <div class="row form-group">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.sendEmailInvite}">Email User:</label>
                                <div class="col-sm-8">
                                    <b-form-checkbox v-model="user.sendEmailInvite" class="mt-2" :value="true" :unchecked-value="false" plain>
                                        Send New User Invite to {{ user.FirstName }}
                                    </b-form-checkbox>

                                    <span v-if="errors.sendEmailInvite" class="text-danger">
                                        <span v-for="error in errors.sendEmailInvite">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div class="row form-group" v-if="showAllowPasswordLogin()">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.allow_password_login}">Use Password Login:</label>
                                <div class="col-sm-8">
                                    <b-form-checkbox v-model="user.allow_password_login" class="mt-2" :value="1" :unchecked-value="0" plain>
                                        Overrides SSO and allows this user to login via password
                                    </b-form-checkbox>

                                    <span v-if="errors.allow_password_login" class="text-danger">
                                        <span v-for="error in errors.allow_password_login">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card mt-4">
                        <div class="card-header">
                            Set Current Jobsite
                        </div>
                        <div class="card-body">
                            <p>This will default the users Jobsite to the selected value below when creating anything that requires a Jobsite (Incident, Inspection, Observation, MIC, etc.)</p>
                            <div class="form-group row">
                                <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.current_jobsite_id }">Jobsite:</label>
                                <div class="col-sm-8">

                                    <jobsite-select :selectedValues="JobsiteValues" @vselected="onJobSiteSelectUpdate" :hasError="errors.current_jobsite_id ? true : false"></jobsite-select>

                                    <span v-if="errors.current_jobsite_id" class="text-danger">
                                        <span v-for="error in errors.current_jobsite_id">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4" v-if="roles.length > 0">
                    <div class="card mb-3">
                        <div class="card-header"><strong><i class="fa fa-lock"></i> Roles</strong></div>
                        <div class="card-body">
                            <b-form-checkbox-group v-model="selectedRoles" plain>
                                <div v-for="role in roles">
                                    <b-form-checkbox :value="role.id">{{ role.name }}</b-form-checkbox>
                                </div>
                            </b-form-checkbox-group>
                        </div>
                    </div>
                    <div class="card mb-3" v-if="planHasLimit">
                        <div class="card-header"><strong :class="{'text-danger': errors.user_license_error}">User Licenses</strong></div>
                        <div class="card-body">
                            <div class="form-group">
                                Standard Licenses:
                                <span class="text-info" :title="`You are using ${active_users.standard} license(s) of your ${billable_users.full_price_users} Standard Licenses`">
                                    {{ active_users.standard }} / {{ billable_users.full_price_users }}
                                </span>
                            </div>
                            <div v-if="errors.user_license_error" class="alert alert-danger">
                                <p v-for="error in errors.user_license_error">{{ error }}</p>
                                <p>
                                    To add licenses, have an account administrator visit the <router-link :to="`/billing`">Account Billing Settings</router-link> page.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-3" v-else-if="errors.user_license_error">
                        <div class="card-header"><strong :class="{'text-danger': errors.user_license_error}">User License Error(s)</strong></div>
                        <div class="card-body">
                            <div class="alert alert-danger">
                                <p v-for="error in errors.user_license_error">{{ error }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="alert alert-warning mt-3" v-if="auto_deactivated">
                You have reached your license limit. This user has been {{ userId ? 'updated' : 'created' }} but marked inactive. To Activate this user, increase your licenses under <router-link to="/billing">Account Billing Settings</router-link>.
            </div>

            <div class="mt-3">
                <button type="button" class="btn btn-success" v-on:click="saveUser()" :disabled="saving">
                    <template v-if="user.UserId">Update</template>
                    <template v-else>Create</template>
                    User
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                UserId: this.$route.params.id,
                query: this.$route.query,
                user: {},
                timezones: {},
                roles: [],
                jobsites: [],
                selectedRoles: [],
                errors: {},
                subcontractors: [],
                sub_permissions:{
                    'Manage Pre-Qualification': 'Manage Pre-Qualification',
                },
                new_password: null,
                new_password_confirmed: null,
                login_type: null,
                account_domain: null,
                auto_deactivated: null,
                active_users: {},
                billable_users: {},
                billing_plan_id: null,
                empDetails: {},
            }
        },

        computed: {
            isAdmin(){
                return this.$store.state.user.is_admin;
            },

            JobsiteValues(){
                if(!this.user.current_jobsite_id || this.user.current_jobsite == null)
                {
                    return null;
                }

                //Send it
                return this.user.current_jobsite;
            },

            userEmployee(){
                //check for null
                if(!this.user.EmployeeId)
                {
                    return {};
                }

                //Return the values
                return {EmployeeId: this.user.EmployeeId, FirstName: this.user.EmployeeFirstName, LastName: this.user.EmployeeLastName, EmployeeNumber: this.user.EmployeeNumber};
            },

            planHasLimit(){
                //Check the account
                if(this.billing_plan_id == 2 || this.billing_plan_id == 4)
                {
                    return true;
                }

                return false;
            }
        },


        methods: {
            //On Select
            onJobSiteSelectUpdate(jobsite){
                //Check for null
                if(jobsite == null)
                {
                    this.user.current_jobsite_id = null;
                }

                //Set the ID
                this.user.current_jobsite_id = jobsite.JobsiteId;
            },

            setUserEmployee(employee){
                //Check for null
                if(!employee)
                {
                    this.user.EmployeeId = null;
                    return;
                }

                //Else
                this.user.EmployeeId = employee.EmployeeId;
            },

            showNewEmpModal(){

                this.empDetails.FirstName = this.user.FirstName;
                this.empDetails.LastName = this.user.LastName;
                this.empDetails.email = this.user.email;

                this.$refs.newEmpModal.getEmployee();

                //Show it
                this.$refs.newEmpModal.show();
            },

            restoreUser: function() {
                if (confirm('Are you sure you want to restore this user?'))
                {
                    this.loading = true;

                    this.$http
                        .post(`users/restore/${this.errors.restore_user}`)
                        .then(response => {
                            this.loading = false;
                            this.$router.push('/users/view/' + response.data.UserId);
                        })
                        .catch(response => {

                        });
                }
            },

            reactivateUser: function() {
                this.$router.push(`/users/edit/${this.errors.reactivate_user}`);
            },

            switchUser: function() {
                this.$router.push(`/users/edit/${this.errors.existing_user}`);
            },

            getUser() {
                //Get the data
                this.$http
                    .get('users/edit' + (this.UserId ? '/' + this.UserId : ''), this.query)
                    .then(response => {
                        //Set all the data
                        this.user = response.data.user;
                        this.roles = response.data.roles;
                        this.selectedRoles = response.data.selectedRoles;
                        this.timezones = response.data.timezones;
                        this.subcontractors = response.data.subcontractors;
                        this.login_type = response.data.login_type;
                        this.account_domain = response.data.account_domain;
                        this.active_users = response.data.active_users;
                        this.billable_users = response.data.billable_users;
                        this.billing_plan_id = response.data.billing_plan_id;
                        this.jobsites = response.data.jobsites;

                        //Check for a SUB
                        if (!this.UserId && this.query.sub_id)
                        {
                            this.user.subcontractor_id = this.query.sub_id;
                        }

                        this.empDetails.FirstName = this.user.FirstName;
                        this.empDetails.LastName = this.user.LastName;
                        this.empDetails.email = this.user.email;
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Set loading
                        this.loading = false;
                    });
            },

            saveUser: function() {
                //Show loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Set the users roles
                this.user.roles = this.selectedRoles;

                //Set the password
                this.user.password = this.new_password;
                this.user.password_confirmation = this.new_password_confirmed;

                //Send it
                this.$http
                .post('users/edit' + (this.UserId ? '/' + this.UserId : ''), this.user)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('User Saved');

                    //Check for a Custom Message
                    if(response.data.auto_deactivated)
                    {
                        //Alert the User
                        this.auto_deactivated = response.data.auto_deactivated
                        this.user = response.data.user;
                    }
                    else
                    {
                        //Return to main list?
                        this.$router.push('/users/view/' + response.data.user.UserId);
                    }
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },

            showAllowPasswordLogin(){
                //Check the Login Type
                if(this.login_type !== 'graph' || !this.account_domain || !this.user.email)
                {
                    return false;
                }

                //Check the email domain
                var emailParts = this.user.email.split('@');

                //Check the second part
                if(emailParts[1] && emailParts[1].toLowerCase() === this.account_domain.toLowerCase())
                {
                    //Yes
                    return true;
                }

                //Default
                return false;
            },
        },

        mounted() {
            //Get the incidents
            this.getUser();
        }
    }
</script>
